import React from 'react';
import PropTypes from 'prop-types';

export default function LayersIcon(props) {
  return (
    <svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M12.6051 18.535C12.2451 18.815 11.7351 18.815 11.3751 18.535L5.22506 13.755C4.86658 13.475 4.36353 13.475 4.00506 13.755C3.49506 14.155 3.49506 14.925 4.00506 15.325L10.7651 20.585C11.4851 21.145 12.4951 21.145 13.2251 20.585L19.9851 15.325C20.4951 14.925 20.4951 14.155 19.9851 13.755L19.9751 13.745C19.6166 13.465 19.1135 13.465 18.7551 13.745L12.6051 18.535Z' fill={props.color || '#AEB6BF'} />
      <path d='M13.2351 15.515L19.9951 10.255C20.5051 9.855 20.5051 9.075 19.9951 8.675L13.2351 3.415C12.5151 2.855 11.5051 2.855 10.7751 3.415L4.01506 8.685C3.50506 9.085 3.50506 9.865 4.01506 10.265L10.7751 15.525C11.4951 16.085 12.5151 16.085 13.2351 15.515Z' fill={props.color || '#AEB6BF'} />
    </svg>
  );
}

LayersIcon.propTypes = {
  color: PropTypes.string
};